export default __webpack_public_path__ + "static/media/32.4216f271.jpg";